var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "800"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-eye")]), _vm._v(" Visualizar " + _vm._s(_vm.titulo) + " ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": `${_vm.titulo}`,
      "dense": "",
      "outlined": "",
      "readonly": ""
    },
    model: {
      value: _vm.content.nome,
      callback: function ($$v) {
        _vm.$set(_vm.content, "nome", $$v);
      },
      expression: "content.nome"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Nível de Ensino",
      "dense": "",
      "outlined": "",
      "readonly": ""
    },
    model: {
      value: _vm.content.nivelDeEnsino.descricao,
      callback: function ($$v) {
        _vm.$set(_vm.content.nivelDeEnsino, "descricao", $$v);
      },
      expression: "content.nivelDeEnsino.descricao"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Componente Curricular",
      "dense": "",
      "outlined": "",
      "readonly": ""
    },
    model: {
      value: _vm.content.componenteCurricular.descricao,
      callback: function ($$v) {
        _vm.$set(_vm.content.componenteCurricular, "descricao", $$v);
      },
      expression: "content.componenteCurricular.descricao"
    }
  }), _c('v-textarea', {
    attrs: {
      "label": "O que é esperado do aluno",
      "outlined": "",
      "rows": "4",
      "dense": "",
      "readonly": ""
    },
    model: {
      value: _vm.content.descricao,
      callback: function ($$v) {
        _vm.$set(_vm.content, "descricao", $$v);
      },
      expression: "content.descricao"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "btn-group text-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")]), _vm._v(" Fechar ")], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }